import { v4 as uuid } from "uuid";

import { createApiMutationHook, IApiMutationFunction } from "../../utils";
import { ILanguageResource } from "../types";

export interface ILanguageCreateMutationParameters {
    uuid?: string;
    title: string;
    locale: string;
}

export type ILanguageCreateMutationResult = ILanguageResource;

export const languageCreateMutation: IApiMutationFunction<ILanguageCreateMutationParameters> = ({
    uuid: providedUuid,
    title,
    locale,
}) => ({
    method: "POST",
    url: "/languages",
    data: {
        uuid: providedUuid ?? uuid(),
        title,
        locale,
    },
});

export const useLanguageCreateMutation = createApiMutationHook<
    ILanguageCreateMutationParameters,
    ILanguageCreateMutationResult
>(languageCreateMutation);
